import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { GLOBAL } from "./global";
import { map } from "rxjs/operators";

@Injectable({
  providedIn: "root",
})
export class LogManifestService {
  public url: string;

  constructor(private _http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token, task): Observable<any> {
    let json = JSON.stringify(task);
    json = json;
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(`${this.url}/logmanifest/new?page=${page}`, params, {
      headers: headers,
    });
  }

  getChat(token, id): Observable<any> {
    let params = new HttpParams().set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(
      `${this.url}/logmanifest/listbyfather/${id}?page=${page}`,
      params,
      { headers: headers }
    );
  }

  update(token, task, id): Observable<any> {
    let json = JSON.stringify(task);
    json = json;
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }

    return this._http.post(
      `${this.url}/logmanifest/edit/${id}?page=${page}`,
      params,
      { headers: headers }
    );
  }

  remove(token, id): Observable<any> {
    let params = new HttpParams().set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    let page = 1;
    if (page == null) {
      page = 1;
    }
    return this._http.post(
      `${this.url}/logmanifest/remove/${id}?page=${page}`,
      params,
      { headers: headers }
    );
  }
  edit(token, task, chat_id): Observable<any> {
    let json = JSON.stringify(task);
    let params = new HttpParams().set("json", json).set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    return this._http.post(`${this.url}/logmanifest/edit/${chat_id}`, params, {
      headers: headers,
    });
  }
  viewMessage(token, pi_id): Observable<any> {
    let params = new HttpParams().set("authorization", token);
    let headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });
    return this._http.post(`${this.url}/logmanifest/viewmessage/${pi_id}`, params, {
      headers: headers,
    });
  }
}
